import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PortService } from 'src/app/core-services/port.service';
import { Router } from '@angular/router';

export interface TrackigStatus {
  value: number;
  viewValue: string;
}

@Component({
  selector: 'app-tracking-list',
  templateUrl: './tracking-list.component.html',
  styleUrls: ['./tracking-list.component.scss']
})
export class TrackingListComponent implements OnInit {

  pageNo: number = 1;
  pageSize: number = 10;
  userId: number = 0;
  searchText: string = '';
  trackingData: any = [];
  totalCount: number = 0;
  loggedInUser: any;
  selectedStatusn: any;
  selectedStatusnId: number = 0;

  trackigStatus: TrackigStatus[] = [
    { value: 0, viewValue: 'Select Status' },
    { value: 1, viewValue: 'On Time' },
    { value: 2, viewValue: 'Delayed' }
  ]

  constructor(private spinner: NgxSpinnerService, private toastr: ToastrService, private portService: PortService, private router: Router) {
    var currentUser = localStorage.getItem('currentUser');
    if (currentUser != null && currentUser != undefined) {
      this.loggedInUser = JSON.parse(currentUser);
      if (this.loggedInUser != null && this.loggedInUser.usersDetailsVM != null) {
        this.userId = this.loggedInUser.usersDetailsVM.id;
      }
    }
  }

  ngOnInit() {
    this.getTrackingList();
  }

  getTrackingList() {
    if (this.userId > 0 && this.pageNo > 0 && this.pageSize > 0) {
      var data = {
        UserId: this.userId,
        PageNo: this.pageNo,
        RecPerPage: this.pageSize,
        SearchText: this.searchText,
        StatusId: this.selectedStatusnId
      }
      this.spinner.show();
      this.portService.getTrackingList(data).subscribe((response: any) => {
        if (response != null && response.content != null && response.content.contents != null) {
          this.trackingData = response.content.contents;
          this.totalCount = response.content.totalCount;
          this.spinner.hide();
        }
        this.spinner.hide();
      })
    }
  }

  filterSearch(event) {
    if (event != null) {
      this.searchText = event;
      this.getTrackingList();
    }
  }
  getTrackingDetails(trackingNumber, shippId, vesselsId, fromPortId, toPortId) {
    if (trackingNumber) {
      var url = 'tracking/' + trackingNumber;
      this.router.navigate([url]);
    }
  }
  onChangeStatus() {
    if (this.selectedStatusn != null && this.selectedStatusn.value > 0) {
      this.selectedStatusnId = this.selectedStatusn.value;
    }
    else {
      this.selectedStatusnId = 0
    }
    this.getTrackingList();
  }
  paginate(event) {
    this.pageNo = event.page + 1;
    this.pageSize = event.rows;
    this.getTrackingList();
  }
}
